import {Button, Card, Col, Row, Table} from "elemental"
import {Link} from "react-router"
import React, {Component} from "react"
import shop from "../shop/shop"
import _ from "lodash"
import moment from "moment"
import ResetPasswordButton from "components/ResetPassword/ResetPasswordButton"

export default class AccountPage extends Component {
  constructor() {
    super()
    this.state = {
      orders: [],
      session: shop.session || {}, locations: []
    }
  }

  loadSession = (session) => {
    this.setState({ session, orders: []})
    console.log("orders::set", this.state.orders);
  }

  componentDidMount() {
    shop.events.authentified.add(this.loadSession)
    shop.fetch("data/customers/current/addresses/deliver").then(locations => {
      console.log(`locations`, locations)
      this.setState({locations})
    })

    shop.fetch( "data/orders?start=0&count=500&open=0" )
      .then( orders => {
        console.log( `orders`, orders )
        this.setState( { orders: orders.values } )
      } )
  }

  componentWillUnmount() {
    shop.events.authentified.remove(this.loadSession)
  }

  render() {
    let locations = _.map(this.state.locations, (location, key) => {
      return (
        <Col key={key}
             sm="1/3">
          <Address title="Anschrift"
                   location={location}/>
        </Col>
      )
    })

    let { orders} = this.state
    // let client    = session.value || {}
    return (
      <div className="container pt4">
        <h1 className="page-title"><i className="icon-vcard icon-lg"/><strong>Mein Konto</strong></h1>
        <p>Lieferanschrift, Rechnungsanschrift und Bestellhistorie</p>

        <section className="pt4">
          <h3>Lieferanschriften</h3>
          {locations.length === 0 && <p>
            Keine Adressen hinterlegt
          </p>}
          <Row>
            {locations}
          </Row>
        </section>


        <section className="pt4">
          <h3>Rechnungsanschrift</h3>
          <Address location={{...shop.session.value, mapid: "Rechnungsanschrift"}}/>
        </section>



        <section className="mt4">
          <Row>
            <Col sm="1">
              <h3>Ihre Bestellungen</h3>
              <OrderTable orders={orders} />
            </Col>
          </Row>
        </section>

        <section className="mt4">
          <h3>{translate("reset.reset")}</h3>
          <ResetPasswordButton email={shop.session.value.email}/>
        </section>


        {/*<pre>Session: {JSON.stringify(session, null, 2)}</pre>*/}
        {/*<pre>Adressen:{JSON.stringify(this.state.locations, null, 2)}</pre>*/}
      </div>
    )
  }
}


const OrderTable = ({ orders = {} }) => {
  if (orders.length === 0) {
    return (<p>Keine Bestellungen gefunden.</p>)
  }

  return (
      <div className="table-scroller">
        <Table>
          <colgroup>
            <col width="65%" />
            <col width="10%" />
            <col width="10%" />
            <col width="10%" />
            <col width="5%" />
          </colgroup>

          <tbody>
            <tr>
              <th className="ttu">Bestellung</th>
              <th className="ttu tr">Preis</th>
              <th className="ttu tc">Positionen</th>
              <th className="ttu tc">Datum</th>
              <th className="ttu tc">Status</th>
            </tr>
            {orders.length > 0 && orders.map((order) => <OrderPreviewRow key={order.id} order={order} />)}
          </tbody>
        </Table>
      </div>
  )
}

const OrderPreviewRow = ({ order }) => {
  const orderDate = moment(order.register).format('DD-MM-YYYY')
  const orderLink = `/account/orders/${order.map_id}`
  const isSuccess = (order.status === 2)

  return (
    <tr>
      <td>
        <Link to={orderLink}>
          <Button className="mr2">
            <i className="icon-info-circled"></i> Anzeigen
          </Button>
        </Link>

        #{order.map_id} {order.comment ? `- ${order.comment}` : ""}
        </td>
      <td className="tr">{order.netto} €</td>
      <td className="tc">{order.positions.length}</td>
      <td className="tc">{orderDate}</td>
      <td className="tc">{isSuccess ? <i className="icon-ok"></i> : <i className="icon-cancel"></i>}</td>
    </tr>
  )
}

const Address = ({title, location}) => {
  return (
    <div className="address-block">
      <div className={"black-60 f6"}>#{location.mapid}</div>
      <Card className="">
        <div >{location.name1} {location.name2} {location.name3} {location.title}</div>
        <div className="block"><strong>{location.company}</strong>
          <br />
          {location.street}<br />
          {location.pcode}, {location.city}<br />
          <br />
          {location.country}<br />
        </div>
      </Card>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/AccountPage.js